module.exports = __webpack_public_path__ + "img/H5_2.6871a1ad.png";